import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {TimelineLite} from "gsap";
import {ThorGameMode} from "../../gamemode/ThorGameMode";
import {ThorParsedGameData} from "../../server/data/ThorParsedGameData";
import {ThorParsedInitData} from "../../server/data/ThorParsedInitData";
import {AnimatedScatter} from "../../symbols/AnimatedScatter";
import {ThorGameModuleConfig} from "../../ThorGameModuleConfig";
import {ThorSoundConfig} from "../../ThorSoundConfig";
import {ThorScatterNudgeWPController} from "../../winpresentation/scatternudge/ThorScatterNudgeWPController";

/**
 * Created by Jerker Nord on 2018-12-05.
 */

export class ThorScatterRespinController extends ReelStopPresentationController {

    public static readonly STOP_SCATTER_IDLE_2_LOOPING:string = "ThorScatterRespinController_StopScatterIdle2Looping";

    private _enableScatterCounter:boolean;
    private _disableScatterCounter:boolean;
    private _collectedScattersBefore:number;
    private _collectedScattersAfter:number;
    private _reels:string[][];
    private _firstScatterHasLanded:boolean;
    private _firstScatterAnimationPlaying:boolean;
    private _firstScatter:AnimatedScatter;
    private _firstScatterReel:number;
    private _scattersPlaying:StateReelSymbol[];
    private _moreScatters:AnimatedScatter[];
    private _scattersToCollect:boolean[];
    private _collectedScatters:number;
    private _landedScatterCount:number;
    private _scatterPositionsBefore:number[];
    private _scatterPositionsAfter:number[];

    constructor(index:number) {
        super(index, "ThorRandomWildsController");
        this._scattersPlaying = [];
        this._moreScatters = [new AnimatedScatter(0, 0), new AnimatedScatter(0, 0), new AnimatedScatter(0, 0),
            new AnimatedScatter(0, 0), new AnimatedScatter(0, 0)];
        this._scattersToCollect = [false, false, false, false, false];
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ThorScatterRespinController.STOP_SCATTER_IDLE_2_LOOPING, (event:GameEvent):void => this.onStopScatterIdle2Looping(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ScreenEvent.GAME_RESTORE, (event:GameEvent) => this.onRestore());
        EventHandler.addEventListener(this, SpinEvent.STOPPED, () => this.onSpinStopped());
    }

    private onInitDataParsed(data:ThorParsedInitData):void {
        this._landedScatterCount = data.landedScatterCount;
        this._collectedScatters = data.collectedScatters;
        for(let i:number = 0; i < data.reels.length; i++) {
            for(let j:number = 3; j < 6; j++) {
                if(data.reels[i][j] == "S") {
                    this._moreScatters[i] = new AnimatedScatter(i, (j - 3));
                    this._moreScatters[i].scatterCollected = true;
                }
            }
        }
    }

    private onRestore():void {
        if(this._landedScatterCount > 0 || this._collectedScatters > 0) {
            this._firstScatterHasLanded = true;
        }
    }

    protected parseFeatureGameData(data:ThorParsedGameData):void {
        this._scatterPositionsBefore = data.scatterPositionsBefore;
        this._scatterPositionsAfter = data.scatterPositionsAfter;
        this._collectedScattersBefore = data.collectedScattersBefore;
        this._collectedScattersAfter = data.collectedScattersAfter;
        this._reels = data.reels;
        this._firstScatterHasLanded = false;
        this._firstScatterAnimationPlaying = false;
        if(data.mode == ThorGameMode.NORMAL && data.nextMode == ThorGameMode.SCATTER_RESPIN) {
            this._enableScatterCounter = true;
            this._disableScatterCounter = false;
        }
        if(data.mode == ThorGameMode.SCATTER_RESPIN && data.nextMode == ThorGameMode.NORMAL) {
            this._enableScatterCounter = false;
            this._disableScatterCounter = true;
            this._scattersPlaying = [];
        }
        if(data.nextMode == ThorGameMode.FREESPIN) {
            this._scattersPlaying = [];
        }
        if(data.mode == ThorGameMode.SCATTER_RESPIN && data.nextMode == ThorGameMode.SCATTER_RESPIN) {
            //Don't play first scatter land animation if we are in scatter respin mode.
            this._firstScatterHasLanded = true;
        }

        if(data.mode == ThorGameMode.SCATTER_RESPIN || data.nextMode == ThorGameMode.SCATTER_RESPIN) {
            for(let i:number = 0; i < data.reels.length; i++) {
                for(let j:number = 3; j < 6; j++) {
                    if(data.reels[i][j] == "S") {
                        //if(j == 5) {
                        this._scattersToCollect[i] = true;
                        //}
                        break;
                    } else {
                        this._scattersToCollect[i] = false;
                    }
                }
            }
        }
    }

    public onReelBounce(data:IReelStoppedData):void {
        for(let i:number = 3; i < 6; i++) {
            if(this._reels[data.reelId][i] == "S") {
                SlotGame.sound.playEffect(ThorSoundConfig.instance.SCATTER_LANDING);
                let scatterSymbol:StateReelSymbol = <StateReelSymbol>Reels.getSymbol(data.reelId, (i - 3));

                //Check if it's a new Scatter sym
                if(this._scatterPositionsAfter[data.reelId] > -1 && (this._scatterPositionsBefore[data.reelId] < 0 || this._reels[data.reelId][this._scatterPositionsAfter[data.reelId] + 3] == "S")) {
                    this._scattersPlaying.push(scatterSymbol);
                    //Check if this is the first Scatter
                    if(this._firstScatterHasLanded == false) {
                        this._firstScatterHasLanded = true;
                        this._firstScatterAnimationPlaying = true;
                        this._firstScatter = new AnimatedScatter(data.reelId, (i - 3));
                        this._firstScatter.scatterSymbol = scatterSymbol;
                        this._firstScatterReel = data.reelId;
                        this._firstScatter.playFirstScatterLandAnimation();
                    } else {
                        // If first scatter animation is running, make sure it stops
                        if(this._firstScatterAnimationPlaying == true && this._firstScatter) {
                            this._firstScatter.playFirstScatterIdleAnimation = false;
                            this._moreScatters[this._firstScatterReel] = this._firstScatter;
                            this._moreScatters[this._firstScatterReel].playMoreScatterTimeline();
                        }
                        this._moreScatters[data.reelId] = new AnimatedScatter(data.reelId, (i - 3));
                        this._moreScatters[data.reelId].scatterSymbol = scatterSymbol;
                        this._moreScatters[data.reelId].playMoreScatterTimeline();
                    }
                }
            }
        }
    }

    private onStopScatterIdle2Looping(scatterReel:number):void {
        this._moreScatters[scatterReel].stopMoreScatterTimeline();
        this._moreScatters[scatterReel].playScatterCollectTL();
    }

    private onSpinStopped():void {
        //Set Scatter to normal state if only one scatter
        if(this._firstScatterHasLanded == true && this._scattersPlaying.length == 1 && this._firstScatter) {
            this._firstScatter.playFirstScatterIdleAnimation = false;
            this._firstScatterHasLanded = false;
            this._scattersPlaying = [];
            if(this._firstScatter) {
                this._firstScatter.setScatterToNormalState();
            }
        }

        //Play scatter collect animations
        for(let i:number = 0; i < this._scattersToCollect.length; i++) {
            if(this._scattersToCollect[i] == true && this._moreScatters[i].scatterCollected == false) {
                //Tells the win pres to play scatter collect animation
                EventHandler.dispatchEvent(new GameEvent(ThorScatterNudgeWPController.PLAY_SCATTER_COLLECT_ANIMATION, this._moreScatters[i]));
            }
        }
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        if(data.reelId == 3) {
            const enableScatterCounterTL:TimelineLite = new TimelineLite({});
            if(this._enableScatterCounter == true) {
                this._enableScatterCounter = false;
                enableScatterCounterTL.add(() => ThorGameModuleConfig.thorFreeSpinBoxView.showFreeSpinBox());
            }
            if(this._disableScatterCounter == true) {
                this._disableScatterCounter = false;
                enableScatterCounterTL.add(() => ThorGameModuleConfig.thorFreeSpinBoxView.resetScatterMeter());
                enableScatterCounterTL.add(() => ThorGameModuleConfig.thorFreeSpinBoxView.resetFreeSpinEnds());
            }
        }
        this.dispatchCompleteEvent(data.reelId);
    }

    get firstScatter():AnimatedScatter {
        return this._firstScatter;
    }
}